
import { createSelector } from 'reselect';
import { initialState } from './reducer';

const selectChecklists = (state) => state.checklists || initialState;

const makeSelectChecklists = () => createSelector(
	selectChecklists,
	(substate) => substate.checklists,
);

const makeSelectResponses = () => createSelector(
	selectChecklists,
	(substate) => substate.responses,
);
const makeSelectQueChecklists = () => createSelector(
	selectChecklists,
	(substate) => substate.queChecklists,
);
const makeSelectQuePictures = () => createSelector(
	selectChecklists,
	(substate) => substate.quePictures,
);

const makeSelectChecklistsInProgress = () => createSelector(
	selectChecklists,
	(substate) => substate.inProgress,
);

const makeSelectChecklistsLoading = () => createSelector(
	selectChecklists,
	(substate) => substate.loading,
);
const makeSelectChecklistsError = () => createSelector(
	selectChecklists,
	(substate) => substate.checklistsError,
);

const makeSelectResponsessLoading = () => createSelector(
	selectChecklists,
	(substate) => substate.loadingResponses,
);

const makeSelectChecklistsLoadingSendResponse = () => createSelector(
	selectChecklists,
	(substate) => substate.loadingSendResponse,
);

export {
	selectChecklists,
	makeSelectChecklists,
	makeSelectResponses,
	makeSelectQueChecklists,
	makeSelectQuePictures,
	makeSelectResponsessLoading,
	makeSelectChecklistsInProgress,
	makeSelectChecklistsLoading,
	makeSelectChecklistsError,
	makeSelectChecklistsLoadingSendResponse,
};
